import {NxFile} from '../../../../../shared/model/nx-file.model';

export const ICON_FILE = 'iconFile';

export interface EditCategoryFormFields {
  name: string;
  parentCategoryId?: number;
  [ICON_FILE]?: NxFile;
}
